export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 2-4_11.4bd54f07.jpg";